import { render, staticRenderFns } from "./InformForm.vue?vue&type=template&id=5e0b445c&scoped=true&"
import script from "./InformForm.vue?vue&type=script&lang=js&"
export * from "./InformForm.vue?vue&type=script&lang=js&"
import style0 from "./InformForm.vue?vue&type=style&index=0&id=5e0b445c&lang=scss&scoped=true&"
import style1 from "./InformForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0b445c",
  null
  
)

export default component.exports